import type {PropsWithChildren, ReactNode} from "react";
import cn from "classnames";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {capitalize} from "@pg-mono/nodash";

import {useAccordionContext} from "../hooks/use_accordion_context";
import type {AccordionTheme} from "../types/AccordionTheme";

import * as styles from "./Header.module.css";

export interface IProps {
    icon?: ReactNode;
    className?: string;
}

type ClassName = keyof typeof styles;

const getHeaderTheme = (theme: AccordionTheme) => `header${capitalize(theme)}` as ClassName;

export const Header = (props: PropsWithChildren<IProps>) => {
    const context = useAccordionContext(Header.name);

    return (
        <div
            className={cn(styles.header, styles[getHeaderTheme(context.theme)], context.expanded && styles.headerExpanded, props.className)}
            onClick={context.onExpand}
        >
            <div className={styles.headline}>
                {props.icon ? <span className={styles.headlineIcon}>{props.icon}</span> : null} {props.children}
            </div>

            <span className={cn(styles.toggle, context.expanded && styles.rotated)}>
                <ChevronDownIcon size="2" />
            </span>
        </div>
    );
};
import type {PropsWithChildren, ReactNode} from "react";
import cn from "classnames";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {capitalize} from "@pg-mono/nodash";

import {useAccordionContext} from "../hooks/use_accordion_context";
import type {AccordionTheme} from "../types/AccordionTheme";

import * as styles from "./Header.module.css";

export interface IProps {
    icon?: ReactNode;
    className?: string;
}

type ClassName = keyof typeof styles;

const getHeaderTheme = (theme: AccordionTheme) => `header${capitalize(theme)}` as ClassName;

export const Header = (props: PropsWithChildren<IProps>) => {
    const context = useAccordionContext(Header.name);

    return (
        <div
            className={cn(styles.header, styles[getHeaderTheme(context.theme)], context.expanded && styles.headerExpanded, props.className)}
            onClick={context.onExpand}
        >
            <div className={styles.headline}>
                {props.icon ? <span className={styles.headlineIcon}>{props.icon}</span> : null} {props.children}
            </div>

            <span className={cn(styles.toggle, context.expanded && styles.rotated)}>
                <ChevronDownIcon size="2" />
            </span>
        </div>
    );
};
